export default function sameDay(first, second) {
  if (!first || !second) return false
  if (!first.isSame) throw new Error(`sameDay first ${first} is not a moment object`)
  if (!second.isSame) throw new Error(`sameDay second ${second}) is not a moment object`)
  return first.isSame(second)
}
